// extracted by mini-css-extract-plugin
export default {"tab-list":"TabList--tab-list--39knt","tabList":"TabList--tab-list--39knt"};